import React from 'react';
import { Button } from 'react-bootstrap';
import TableConfig from './TableConfig';
import { ChevronDown } from 'react-bootstrap-icons';
import utils from '../../../utils';

function TableDynamic({
    handleSortColumn, 
    data, 
    configType, 
    selectableRows=false,
    handleSelect,
    selectedItems=[],
    handleOpenPanel,
    className
}) {

    return (
        <div id='dynamic-table' className='dynamic-table  overflow-x-auto'>
            <table className={`reusable-table ${className}`}>
                <thead className='z-index-0 border-primary-light'>
                    <tr className='z-index-0'>
                        {selectableRows && (    
                            <th>
                                <input className='p-i-start-03' type="checkbox" onClick={() => handleSelect('select-all')} />
                            </th>
                        )}
                        {
                            TableConfig[configType]().map((column, idx) => (
                                <th key={idx} className={`${column.className} z-index-0`}>
                                    {
                                        column.sort ?
                                            <Button
                                                className='label-medium surface-transparent text-primary-light border-none'
                                                onClick={() => handleSortColumn(column.column)}
                                            >
                                                {column.header}
                                                <ChevronDown />
                                            </Button>
                                        : <div className='label-medium text-primary-light'>{column.header}</div>
                                    }
                                </th>
                            ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item, idx) => {
                            return (
                                <tr key={idx} onClick={() => handleOpenPanel && handleOpenPanel(item)} className={utils.addbackgroundClass(item, configType)}>
                                    {selectableRows && (
                                        <td>
                                            <input 
                                                className='m-i-start-03' 
                                                type="checkbox" 
                                                onClick={e => e.stopPropagation()}
                                                onChange={() => handleSelect(item)} 
                                                checked={selectedItems.some(selected => selected.id === item.id)}
                                            />
                                        </td>
                                    )}
                                    {
                                        TableConfig[configType]().map((cell, idx) => {
                                            return (
                                                <td key={idx} className={`${cell.className} p-b-03 body-medium-condensed`}>{cell.accessor(item)}</td>
                                            )
                                        })
                                    }

                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default TableDynamic;